/* eslint-disable @typescript-eslint/no-explicit-any */

import { TreeNodeRoute, TreeNodeType } from "pages/thermography/components/InspectionRouteTree/types/treeNode";
import { EquipmentInspectionStatus } from "./enumEquipmentInspectionStatus";

export type EquipmentStatusChange = { id: string; status: EquipmentInspectionStatus };

export function markAllEquipmentsAsInspected(node: TreeNodeRoute): TreeNodeRoute {
    const mark = (n: TreeNodeRoute): TreeNodeRoute => {
        if (
            n.type === TreeNodeType.ELEMENT &&
            (n.status === EquipmentInspectionStatus.NOT_INSPECTED || n.status == null)
        ) {
            return { ...n, status: EquipmentInspectionStatus.INSPECTED };
        }

        return {
            ...n,
            children: n.children.map(mark),
        };
    };

    return mark(node);
}

export function allEquipmentsInspected(node: TreeNodeRoute): boolean {
    const check = (n: TreeNodeRoute): boolean => {
        if (n.type === TreeNodeType.ELEMENT) {
            const status = n.status ?? EquipmentInspectionStatus.NOT_INSPECTED;
            return status !== EquipmentInspectionStatus.NOT_INSPECTED;
        }
        return n.children.every(check);
    };

    return check(node);
}

export const collectEquipmentsToUpdate = (node: TreeNodeRoute): EquipmentStatusChange[] => {
    const equipments: EquipmentStatusChange[] = [];

    const walk = (current: TreeNodeRoute) => {
        if (
            current.type === TreeNodeType.ELEMENT &&
            (current.status === EquipmentInspectionStatus.NOT_INSPECTED || current.status == null)
        ) {
            equipments.push({
                id: current.id,
                status: EquipmentInspectionStatus.INSPECTED,
            });
        }

        current.children.forEach(walk);
    };

    walk(node);
    return equipments;
};
